// ============== plugin import ================ //
import React,{useEffect, useRef} from 'react'
import ApexCharts from 'apexcharts'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faTable, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { useParams } from "react-router-dom";

// ============ module import ============ //
import { PageTitle } from "../../../../../_template/layout/core/PageData";
import SAISVG from '../../../../../_template/helpers/CommonFunction';

// ============== component import ============= //

const AgentAnalytics = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');

    const productType = [
        { value: 'option 1', label: 'Option 1' },
        { value: 'option 2', label: 'Option 2' },
        { value: 'option 3', label: 'Option 3' },
        { value: 'option 4', label: 'Option 4' },
        { value: 'option 5', label: 'Option 5' },
    ]
    const agentAnalyticsTitle = [
        {
            title: 'Agents',
            path: loginUserType === 'SA' ? `${company}/agents/` : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        {
            title: 'Analytics',
            path: loginUserType === 'SA' ? `${company}/analytics/agent-analytics` : '/analytics/agent-analytics',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const chartRef = useRef(null);
    const refreshMode = () => {
        if (!chartRef.current) {
          return;
        }
        const height = parseInt(350);
        const chart = new ApexCharts(chartRef.current, getChartOptions(height));
        if (chart) {
          chart.render();
        }
        return chart;
    };

    useEffect(() => {
        setTimeout(() => {
            const chart = refreshMode();
       
            if (chart) {
                chart.updateOptions({
                    chart: { height: 350 },
                });
            }
        
            return () => {
                if (chart) {
                    chart.destroy();
                }
            };
        }, 200);
            
    }, [chartRef]);

    return (
        <>
            <PageTitle breadcrumbs={agentAnalyticsTitle}>Agent Analytics</PageTitle>
            <div className="row">
                <div className="col-md-3">
                    <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-xl-100 bg-dark">
                        <div className="card-header pt-5 mb-3">
                            <div className="d-flex flex-center rounded-circle h-80px w-80px bg-dark" style={{border: '1px dashed rgba(255, 255, 255, 0.4)'}}>
                                <SAISVG path="media/icons/duotune/general/gen026.svg" className="svg-icon-muted svg-icon-5hx" />
                            </div>
                        </div>
                        <div className="card-body d-flex align-items-end mb-3 py-3">
                            <div className="d-flex align-items-center">
                                <span className="fs-4x text-white fw-bold me-6 inactive-vehicle-count">20</span>
                            </div>
                        </div>
                        <div className="card-footer py-3" style={{borderTop : '1px solid rgba(255, 255, 255, 0.3)', background:'rgba(0, 0, 0, 0.15)'}}>
                            <div className="fw-bold text-white py-2">
                                <span className="fs-2 d-block">Total Session</span>
                                <span className="opacity-50">Total Session</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-xl-100 bg-danger">
                        <div className="card-header pt-5 mb-3">
                            <div className="d-flex flex-center rounded-circle h-80px w-80px bg-danger" style={{border: '1px dashed rgba(255, 255, 255, 0.4)'}}>
                                <SAISVG path="media/icons/duotune/general/gen026.svg" className="svg-icon-white svg-icon-5hx" />
                            </div>
                        </div>
                        <div className="card-body d-flex align-items-end mb-3 py-3">
                            <div className="d-flex align-items-center">
                                <span className="fs-4x text-white fw-bold me-6 inactive-vehicle-count">8</span>
                            </div>
                        </div>
                        <div className="card-footer py-3" style={{borderTop : '1px solid rgba(255, 255, 255, 0.3)', background:'rgba(0, 0, 0, 0.15)'}}>
                            <div className="fw-bold text-white py-2">
                                <span className="fs-2 d-block">Rejected Session</span>
                                <span className="opacity-50">rejected Session</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-xl-100 bg-success">
                        <div className="card-header pt-5 mb-3">
                            <div className="d-flex flex-center rounded-circle h-80px w-80px bg-success" style={{border: '1px dashed rgba(255, 255, 255, 0.4)'}}>
                                <SAISVG path="media/icons/duotune/general/gen026.svg" className="svg-icon-white svg-icon-5hx" />
                            </div>
                        </div>
                        <div className="card-body d-flex align-items-end mb-3 py-3">
                            <div className="d-flex align-items-center">
                                <span className="fs-4x text-white fw-bold me-6 inactive-vehicle-count">6</span>
                            </div>
                        </div>
                        <div className="card-footer py-3" style={{borderTop : '1px solid rgba(255, 255, 255, 0.3)', background:'rgba(0, 0, 0, 0.15)'}}>
                            <div className="fw-bold text-white py-2">
                                <span className="fs-2 d-block">Accepted Session</span>
                                <span className="opacity-50">accepted Session</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-xl-100 bg-warning">
                        <div className="card-header pt-5 mb-3">
                            <div className="d-flex flex-center rounded-circle h-80px w-80px bg-warning" style={{border: '1px dashed rgba(255, 255, 255, 0.4)'}}>
                                <SAISVG path="media/icons/duotune/general/gen026.svg" className="svg-icon-white svg-icon-5hx" />
                            </div>
                        </div>
                        <div className="card-body d-flex align-items-end mb-3 py-3">
                            <div className="d-flex align-items-center">
                                <span className="fs-4x text-white fw-bold me-6">10</span>
                                <span className="fs-2 text-light fw-bold mt-7 active-projects">min</span>
                            </div>
                        </div>
                        <div className="card-footer py-3" style={{borderTop : '1px solid rgba(255, 255, 255, 0.3)', background:'rgba(0, 0, 0, 0.15)'}}>
                            <div className="fw-bold text-white py-2">
                                <span className="fs-2 d-block">Average Duration</span>
                                <span className="opacity-50">average session</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-5">
                <div className='col-md-12'>
                    <div className={`card card-xl-stretch mb-xl-8 border`}>
                        <div className='card-header border-0 pt-5'>
                            <h3 className='card-title align-items-start flex-column'>
                                <span className='card-label fw-bold fs-3 mb-1'>
                                    Agent Analytics
                                </span>
                                <span className='text-muted fw-semibold fs-7'>More than 1000 new records</span>
                            </h3>
                            <div className="card-toolbar">
                                <ul className="nav nav-tabs nav-line-tabs nav-stretch border-transparent fs-5 fw-bold" id="kt_security_summary_tabs" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            type="button"
                                            className="nav-link text-active-primary active"
                                            data-kt-countup-tabs="true"
                                            data-bs-toggle="tab"
                                            data-bs-target="#kt_security_summary_tab_pane_hours"
                                            data-kt-initialized="1"
                                            aria-selected="true"
                                            role="tab"
                                            >
                                            Collective Insight
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            type="button"
                                            className="nav-link text-active-primary"
                                            data-kt-countup-tabs="true"
                                            data-bs-toggle="tab"
                                            data-bs-target="#kt_security_summary_tab_pane_day"
                                            data-kt-initialized="1"
                                            aria-selected="true"
                                            role="tab"
                                            >
                                            Collective Insight
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className='card-body'>
                            <div className="row ">
                                <div className='col-md-4'>
                                    <Select 
                                        className='react-select-styled react-select-solid' 
                                        classNamePrefix='react-select' 
                                        options={productType} 
                                        placeholder='Select an option' 
                                    />
                                </div>
                                <div className='col-md-4'>
                                    <input
                                        type="text"
                                        className="form-control form-control-solid"
                                        placeholder="name@example.com"
                                    />
                                </div>
                                <div className='col-md-4 text-end'>
                                    <button type="button" className="btn btn-dark me-2">
                                        <FontAwesomeIcon className='me-2' icon={faMagnifyingGlass} />
                                        Search
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn btn-dark me-2"
                                        data-sai-menu-trigger='click'
                                        data-sai-menu-placement='bottom-end'
                                        data-sai-menu-flip='top-end'
                                    >
                                        
                                        Export
                                        <FontAwesomeIcon className='ms-2' icon={faAngleDown} />
                                    </button>

                                    <div className='menu menu-sub menu-sub-dropdown w-200px w-md-200px' data-sai-menu='true'>
                                        <div className="row p-2">
                                            <div className="col-md-12 text-start">
                                                <div className="menu-item px-3">
                                                    <button className="btn btn-active-light-primary menu-link">
                                                        CSV
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" className="btn btn-primary">
                                        <FontAwesomeIcon icon={faTable} className='fs-4' />
                                    </button>
                                </div>
                            </div>
                            <div ref={chartRef} style={{height: '100%'}} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {AgentAnalytics}

function getChartOptions() {
    const labelColor = '#A1A5B7'
    const borderColor = '#eff2f5'
    const baseColor = '#7239ea'
    const lightColor = '#f8f5ff'

    return {
        series: [
            {
                name: 'Call',
                data: [5, 7, 3, 2, 10, 26, 8, 4, 12, 13, 11, 15, 5, 45, 50, 35, 6, 45, 19, 25, 7, 15, 35, 5],
            },
        ],
        chart: {
            fontFamily: 'inherit',
            type: 'area',
            height: 350,
            redrawOnParentResize: true,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {},
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: false,
        },
        fill: {
            type: 'solid',
            opacity: 1,
        },
        stroke: {
            curve: 'smooth',
            show: true,
            width: 3,
            colors: [baseColor],
        },
      
        xaxis: {
            categories: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21','22', '23', '24'],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
            crosshairs: {
                position: 'front',
                stroke: {
                    color: baseColor,
                    width: 1,
                    dashArray: 3,
                },
            },
            tooltip: {
                enabled: true,
                formatter: undefined,
                offsetY: 0,
                style: {
                    fontSize: '12px',
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '12px',
                },
            },
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
        },
        tooltip: {
            style: {
                fontSize: '12px',
            },
            y: {
                formatter: function (val) {
                    return val
                },
            },
        },
        colors: [lightColor],
        grid: {
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },
        markers: {
            strokeColors: baseColor,
            strokeWidth: 3,
        },
    }
}